import React from 'react'
import DotsIcon from 'assets/icons/dots.svg'
import Button from 'components/Button/Button'
import {
  ClientListItemAvatar,
  ClientListItemText,
  ClientListItemActions,
} from './ClientList.styled'
import { ClientListItemProps } from './ClientListItem.props'
import defaultAvatar from '../../assets/images/user.png'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { useAppDispatch } from 'store'
import { clientActions } from 'store/slices/clients/clients.slice'
import { useHistory } from 'react-router'

const ClientListItem = ({ client, locationId }: ClientListItemProps) => {
  const { push } = useHistory()
  const dispatch = useAppDispatch()
  const handleCheckProfile = () => {
    dispatch(clientActions.setCurrentClient(client))
    push(`/locations/${locationId}/settings/clients/${client.id}`)
  }

  return (
    <TableItemContainer>
      <TableItemBody justify="center">
        <ClientListItemAvatar src={defaultAvatar} alt="default avatar" />
      </TableItemBody>
      <TableItemBody>
        <ClientListItemText>{client.name}</ClientListItemText>
      </TableItemBody>
      <TableItemBody>
        <ClientListItemText>{client.last_name}</ClientListItemText>
      </TableItemBody>
      <TableItemBody>
        <ClientListItemText>{client.email}</ClientListItemText>
      </TableItemBody>
      <TableItemBody>
        <ClientListItemActions>
          <img src={DotsIcon} alt="dots icon" />
          <Button
            preset={'ghost'}
            variant={'primary'}
            text={'Profile'}
            size={'tiny'}
            onClick={handleCheckProfile}
          />
        </ClientListItemActions>
      </TableItemBody>
    </TableItemContainer>
  )
}

export default ClientListItem
